import React from 'react'
import { string, bool } from 'prop-types'
import { styled } from '@creditas/stylitas'

import { Navigation } from '@creditas/icons'

const CellHeader = styled.div`
  cursor: pointer;
  height: 24px;
  user-select: none;
`

const Description = styled.div`
  display: inline;
  height: 24px;
  margin-right: 5px;
  line-height: 24px;
`

const OrderArrows = styled.div`
  display: inline;
  position: relative;
  height: 24px;
  width: 20px;
`

const Arrow = styled.div`
  left: 5px;
  position: absolute;

  svg {
    fill: ${props => (props.active ? '#556666' : '#CCCCCC')};
  }
`

const ArrowUp = styled(Arrow)`
  top: -6px;
`

const ArrowDown = styled(Arrow)`
  top: 6px;
`

const TableCellOrder = ({ children, isOrdered, orientation }) => (
  <CellHeader>
    <Description>{children}</Description>
    <OrderArrows>
      <ArrowUp active={isOrdered && orientation === 'desc'}>
        <Navigation.ChevronUp fontSize="small" />
      </ArrowUp>
      <ArrowDown active={isOrdered && orientation === 'asc'}>
        <Navigation.ChevronDown fontSize="small" />
      </ArrowDown>
    </OrderArrows>
  </CellHeader>
)

TableCellOrder.propTypes = {
  isOrdered: bool,
  orientation: string,
  children: string,
}

export { TableCellOrder }
